import React from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Card from '../CardWrapper/cardWrapper';
import { withStyles } from '@material-ui/core/styles';
import './appWrapper.css';

const styles={
    typography:{
        fontSize:24
    },
    tabs:{
        textAlign: 'center',
        color:'#851679',
        fontSize:'medium',
        fontWeight:600,
    },
    Paper: {
        borderRadius:0,
        position: 'relative',
    },
};


const AppWrapper=(props)=>{
    const { classes,tab } = props;
    return(
        <Card
            paperClasses={classes.Paper}
            header={
                <div>
                    <div align='center'>{props.header}</div>
                    <div align='center'><h4><b>{props.subheader}</b></h4></div>
                </div>
            }
            CardHeaderProps={{
            classes:{
                title:classes.typography
            },
            style:{textAlign: 'center', borderBottom: '1px solid #DDD'}
        }}
            CardContentProps={{
                style: {height:props.height,padding:0}
            }}
            content={
                    <div>
                        <Grid container className={classes.tabs}>
                            <Grid item sm={3} xs={3}><li className={tab===1?"borders":"borders-w"}>About</li></Grid>
                            <Grid item sm={3} xs={3}><li className={tab===2?"borders":"borders-w"}>Album</li></Grid>
                            <Grid item sm={3} xs={3}><li className={tab===3?"borders":"borders-w"}>Moments</li></Grid>
                            <Grid item sm={3} xs={3}><li className={tab===4?"borders":"borders-w"}>Events</li></Grid>
                        </Grid>
                        <Divider/>
                        {props.content}
                </div>

            }
        />
    )
};//style={{borderBottom:'3px solid #A435A6'}}

export default withStyles(styles)(AppWrapper);